import type { JSX } from 'react'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import type { JoiningMode } from '@profiler/shared'

/**
 * How somebody new gets in, as this deployment is set.
 *
 * Read-only on purpose. The mode is a deploy setting, so opening the door takes
 * a reviewed change rather than a click, and the screen only says which one is
 * live. It matters because the same invitation does different things under each.
 */
export function JoiningNotice({ joining }: Readonly<{ joining: JoiningMode }>): JSX.Element {
  if (joining === 'invitation') {
    return (
      <Alert severity="success" variant="outlined">
        <AlertTitle>Joining is by invitation</AlertTitle>
        Only addresses invited here can join Quarry. Somebody who has already joined is stopped by disabling
        their account.
      </Alert>
    )
  }
  return (
    <Alert severity="info" variant="outlined">
      <AlertTitle>Microsoft Entra still decides who can join</AlertTitle>
      Somebody new needs to be assigned to Quarry in Entra. Invitations made here are recorded and checked,
      and become the only thing needed once invitations are switched on.
    </Alert>
  )
}
